export function hexToRGBA(hex, fallbackHex) {
  if (
    /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)
    || /^#([A-Fa-f0-9]{3}){1,2}$/.test(fallbackHex)
  ) {
    const trueHex = /^#([A-Fa-f0-9]{3}){1,2}$/.test(hex) ? hex : fallbackHex;
    let c = trueHex.substring(1).split('');
    if (c.length === 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    c = '0x' + c.join('');
    return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)';
  }
  throw new Error('An invalid hex color was passed in to hexToRGBA(hex, fallbackHex) and either no fallbackHex parameter was provided or it was also an invalid hex color.');
};